import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '@/common/SafeIcon';

const ChatGuider = () => {
  const [isPulsing, setIsPulsing] = useState(false);

  useEffect(() => {
    const handleTrigger = () => {
      setIsPulsing(true);
      setTimeout(() => setIsPulsing(false), 2000);
    };

    window.addEventListener('trigger-chat-highlight', handleTrigger);
    return () => window.removeEventListener('trigger-chat-highlight', handleTrigger);
  }, []);

  return (
    <div className="fixed bottom-24 right-8 z-[9999] pointer-events-none">
      <AnimatePresence>
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ 
            opacity: 1, 
            y: [0, -15, 0],
            scale: isPulsing ? [1, 1.2, 1] : 1
          }}
          transition={{ 
            y: { repeat: Infinity, duration: 2, ease: "easeInOut" },
            scale: { duration: 0.5 }
          }}
          className="flex flex-col items-center gap-2"
        >
          {/* Tooltip */}
          <div className="bg-gold text-navy font-bold px-4 py-2 rounded-lg shadow-2xl text-sm uppercase tracking-tighter whitespace-nowrap border-2 border-white/20">
            Talk to us live
          </div>

          {/* Animated Arrow */}
          <div className="text-gold filter drop-shadow-[0_0_10px_rgba(245,166,35,0.6)]">
            <SafeIcon icon={FiIcons.FiArrowDownRight} className="text-5xl transform rotate-12" />
          </div>
        </motion.div>
      </AnimatePresence>

      {/* Ripple Effect when triggered */}
      {isPulsing && (
        <motion.div 
          initial={{ scale: 0, opacity: 0.5 }}
          animate={{ scale: 4, opacity: 0 }}
          transition={{ duration: 1 }}
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-10 h-10 bg-gold rounded-full"
        />
      )}
    </div>
  );
};

export default ChatGuider;